import { useStaticQuery, graphql } from 'gatsby';
import { lighten } from 'polished';

export default function useEventTheme() {
  const {
    event: { primaryColor, secondaryColor, logo },
  } = useStaticQuery(graphql`
    {
      event {
        primaryColor
        secondaryColor
        logo {
          publicId
        }
      }
    }
  `);
  return {
    logo,
    colors: {
      primary: primaryColor,
      secondary: lighten(0.1)(primaryColor),
      accent: secondaryColor,
    },
  };
}
